import { useEffect } from 'react'
import { logger } from 'shared/lib'

type Props = {
  textFieldElement: HTMLDivElement | null
  replaceTriggerContent: string
  updateTriggerContent: string
  actions: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [K in string]: (chip: HTMLSpanElement, data: any) => void
  }
}

export function useChips({
  textFieldElement,
  replaceTriggerContent,
  updateTriggerContent,
  actions,
}: Props) {
  useEffect(() => {
    if (!textFieldElement) return

    textFieldElement.querySelectorAll('.actionChip-wrap').forEach((chip) => {
      if (!(chip instanceof HTMLSpanElement)) return

      const template = chip.dataset.template ?? ''

      for (const [pattern, onClick] of Object.entries(actions)) {
        const match = template.match(pattern)
        if (match) {
          const [, data] = match

          try {
            const parseData = data ? JSON.parse(data) : undefined
            chip.style.cursor = 'pointer'
            chip.onclick = (e) => {
              e.stopPropagation()
              onClick(chip, parseData)
            }
          } catch (e) {
            logger.error(e)
          }
        }
      }
    })
  }, [textFieldElement, replaceTriggerContent, updateTriggerContent])
}
